import { request } from '@/shared/api/request'

export const getCheckInfo = (id) => request({ url: `selftest/auth/get?id=${id}`, method: 'GET' })
